import React, { useState, useEffect } from 'react';

export default function TreeSearch({ treeData, onSelect, onCenterNode }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!query.trim()) {
      setResults([]);
      return;
    }

    const q = query.toLowerCase();
    const matches = [];

    treeData.nodeMap.forEach((node) => {
      const nameMatch = node.user_name?.toLowerCase().includes(q);
      const emailMatch = node.user_email?.toLowerCase().includes(q);
      const codeMatch = node.affiliate_code?.toLowerCase().includes(q);

      if (nameMatch || emailMatch || codeMatch) {
        matches.push(node);
      }
    });

    setResults(matches.slice(0, 10));
    setIsOpen(matches.length > 0);
  }, [query, treeData.nodeMap]);

  const handleSelect = (node) => {
    onSelect(node.node_id);
    onCenterNode(node.node_id);
    setQuery('');
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <div className="flex items-center bg-background border border-outline rounded-lg overflow-hidden">
        <svg
          className="w-4 h-4 text-on-background/40 ml-3"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
        <input
          type="text"
          placeholder="Search by name, email, or code..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onFocus={() => results.length > 0 && setIsOpen(true)}
          className="flex-1 px-3 py-2 bg-background text-on-background text-body-sm focus:outline-none"
        />
        {query && (
          <button
            onClick={() => {
              setQuery('');
              setResults([]);
              setIsOpen(false);
            }}
            className="px-3 text-on-background/60 hover:text-on-background"
          >
            ✕
          </button>
        )}
      </div>

      {isOpen && results.length > 0 && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-surface border border-outline rounded-lg shadow-lg z-50 max-h-72 overflow-y-auto">
          {results.map((node) => (
            <button
              key={node.node_id}
              onClick={() => handleSelect(node)}
              className="w-full text-left px-4 py-2 hover:bg-primary-container/20 border-b border-outline/50 last:border-b-0 transition-colors"
            >
              <div className="text-body-sm font-medium text-on-background">
                {node.user_name || node.user_email}
              </div>
              <div className="text-body-xs text-on-background/60 font-mono">
                {node.affiliate_code}
              </div>
            </button>
          ))}
        </div>
      )}

      {isOpen && query && results.length === 0 && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-surface border border-outline rounded-lg shadow-lg p-4 z-50">
          <p className="text-body-sm text-on-background/60">No results found</p>
        </div>
      )}
    </div>
  );
}
